// utils/alphabetize.js
export const alphabetize = (array, key, dir = "asc") => {
  if (!Array.isArray(array)) return [];
  const s = dir === "desc" ? -1 : 1;
  return [...array].sort((a, b) =>
    ((a?.[key] ?? "") + "").localeCompare((b?.[key] ?? "") + "") * s
  );
};
